import { toTypedSchema } from "@vee-validate/zod";
import { z } from "zod";

import { i18n } from "@/i18n";

const { t } = i18n.global;

const Login = z.object({
  username: z.string({ required_error: t("validation.required") }),
  password: z.string({ required_error: t("validation.required") })
});

export type Login = z.infer<typeof Login>;

export const loginValidator = toTypedSchema(Login);
